<template>
    <div class="add-graph-box uk-inline show-graph-box-button" @click="showAddGraphMenu">
        <div class="uk-position-center show-graph-box-button">
            <span class="show-graph-box-button">+</span>
            <p class="uk-margin-remove show-graph-box-button">Add another graph</p>
        </div>
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "AddGraphBox",
    props: {
        graphPosition: {
            required: true,
            type: Number,
        },
    },
    methods: {
        showAddGraphMenu() {
            this.$addGraphMenu.show(this.graphPosition);
        },
    },
});
</script>
